import {GedFileDescription, IGedWebServiceClient, LigneCatalogueExamenDto} from "@resources/resources";
import {Http} from "@angular/http";
import {AsiFileService} from "@asi-ngtools/lib";
import {Component, Input} from "@angular/core";

@Component({
  selector: 'list-documents',
  templateUrl: './list-documents.component.html',
  host: {'class': 'cerba-list-documents'}
})
export class ListDocumentsComponent {

  @Input() detail: LigneCatalogueExamenDto;

  documents: Array<GedFileDescription> = [];
  loading: boolean = true;

  constructor(private gedWebServiceClient: IGedWebServiceClient, private fileUtils: AsiFileService, private http: Http) {
  }

  ngOnInit() {
    this.gedWebServiceClient.searchFilesByIdLigneCatalogueExamen({idLigneCatalogueExamen: this.detail.id}).subscribe(data => {
      this.documents = data;
      this.loading = false;
    });
  }

  downloadFile(document: GedFileDescription) {
    this.fileUtils.downloadFile(document.url).subscribe((blob) => {
      console.log(blob);
      //this.saveToFile(blob, "result.csv");
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/detail-examen/list-documents/list-documents.component.ts